const messages = {
    menuTitle: 'Zlecenia',
    pageTitle: 'Zlecenia',

    actions: {
        generateReport: 'Generuj raport',
        productionStatus: 'Status produkcyjny'
    },

    statuses: {
        draft: 'Szkic',
        inProgress: 'W trakcie',
        closed: 'Zamknięte',
        cancelled: 'Anulowane'
    },

    filters: {
        status: 'Status',
        search: 'Szukaj po numerze, nazwie',
        customerName: 'Szukaj po kliencie',
        createdBy: 'Tworzący',
        createdFrom: 'Zlecenie utworzone od',
        createdTo: 'Zlecenie utworzone do',
        hideCancelled: 'Ukryj anulowane'
    },

    usersSearch: {
        searching: 'Trwa wyszukiwanie...',
        emptyPrompt: 'Wpisz treść aby odnaleźć użytkownika.',
        noResults: 'Nie znaleziono'
    },

    table: {
        headers: {
            number: 'Numer zlecenia',
            name: 'Nazwa zlecenia',
            customer: 'Klient',
            status: 'Status',
            createdAt: 'Data utworzenia',
            createdBy: 'Utworzone przez',
            processStatus: 'Etap',
            actions: 'Akcje'
        }
    },

    printReportsDialog: {
        title: 'Drukowanie raportów',
        abortButton: 'Anuluj',
        confirmButton: 'Drukuj',
        headers: {
            report: 'Typ'
        },
        reports: {
            trader: 'Handlowcy',
            print: 'Druk',
            cut: 'Intro',
            ctp: 'CTP'
        }
    },

    impositionStatusesDialog: {
        title: 'Status produkcyjny',
        titleWithJobNumber: 'Status produkcyjny – {jobNumber}',
        headers: {
            impositionNumber: 'Numer montażu',
            status: 'Status'
        }
    },

    details: {
        pageTitle: 'Zlecenie',
        backButton: 'Powrót do listy',
        reprintLabel: 'dodruk',
        relatedDocuments: {
            calculation: 'Kalkulacja',
            order: 'Zamówienie',
            noCalculationPermission: 'Brak uprawnień do przeglądania kalkulacji.',
            noOrderPermission: 'Brak uprawnień do przeglądania zamówień.'
        },
        actions: {
            jobParameters: 'Parametry zlecenia',
            impositionOrdinalNumbers: 'Numeracja montaży',
            bulkEdit: 'Edycja zbiorcza',
            processEdit: 'Edycja procesu',
            processPreview: 'Podgląd procesu',
            printReports: 'Generuj raport',
            customerAdvice: 'Awizacja od klienta',
            forwardJob: 'Przekaż do technologa',
            closeJob: 'Zamknij zlecenie',
            reopenJob: 'Otwórz zlecenie',
            reprintJob: 'Dodruk zlecenia',
            sendMaterialsRequirement: 'Wyślij zapotrzebowanie',
            cancelJob: 'Anuluj zlecenie',
            changeHistory: 'Historia zmian'
        },
        diagram: {
            fullJobView: 'Widok pełnego zlecenia',
            impositionsView: 'Widok montaży',
            impositionSelect: 'Montaż',
            impositionOptionSelect: 'Montaż {index}',
            impositionOption: 'Montaż {index} z {total}',
            deleteProcess: 'Usuń proces',
            fit: 'Dopasuj',
            sort: 'Sortuj',
            placeholder: 'Miejsce na diagram',
            parallelComponentsNotEditable:
                'Edycja komponentów procesów równoległych jest niedostępna w trybie podglądu zlecenia.',
            amounts: {
                bruttoSheets: 'arkuszy brutto: {value}',
                nettoSheets: 'arkuszy netto: {value}'
            },
            table: {
                orderNumber: 'Nr zam.',
                component: 'Komponent',
                parts: 'Użytki',
                nettoAmount: 'Nakład netto'
            }
        },
        addProcessDialog: {
            title: 'Dodawanie nowego procesu',
            before: 'przed procesem',
            after: 'po procesie',
            processLabel: 'Proces',
            parallelProcessLabel: 'Dodaj jako proces równoległy',
            noData: 'Nie znaleziono procesów',
            abortButton: 'Anuluj',
            confirmButton: 'Dodaj'
        },
        shippingOrdersDialog: {
            title: 'Zlecenia spedycyjne',
            closeButton: 'Zamknij',
            openButton: 'Przejdź',
            headers: {
                number: 'Numer ZS',
                actions: 'Akcje'
            }
        },
        copyTaskParametersDialog: {
            title: 'Wybierz proces źródłowy do skopiowania',
            noData: 'Nie znaleziono procesów'
        },
        deleteProcessDialog: {
            title: 'Usuwanie procesu',
            content: 'Czy na pewno chcesz usunąć proces?',
            confirmButton: 'Tak'
        },
        forwardJobDialog: {
            title: 'Przekazanie zlecenia do technologa',
            content: 'Czy na pewno chcesz przekazać zlecenie do technologa?',
            confirmButton: 'Tak'
        },
        closeJobDialog: {
            title: 'Zamykanie zlecenia',
            content: 'Czy na pewno chcesz zamknąć zlecenie i przekazać je do planu?',
            confirmButton: 'Zamknij'
        },
        reopenJobDialog: {
            title: 'Otwieranie zlecenia',
            content: 'Czy na pewno chcesz otworzyć zlecenie?',
            confirmButton: 'Otwórz'
        },
        cancelJobDialog: {
            title: 'Anulowanie zlecenia',
            content: 'Czy na pewno chcesz anulować zlecenie?',
            confirmButton: 'Potwierdź'
        },
        sendMaterialsRequirementDialog: {
            title: 'Wyślij zapotrzebowanie',
            content: 'Czy chcesz wysłać zapotrzebowanie?',
            confirmButton: 'Tak',
            abortButton: 'Nie'
        },
        changeHistoryDialog: {
            title: 'Historia zmian',
            headers: {
                user: 'Kto',
                createdAt: 'Kiedy'
            }
        },
        reprintJobDialog: {
            title: 'Wybierz montaże i procesy do dodruku',
            fields: {
                createShippingOrder: 'Utwórz zlecenie spedycyjne'
            },
            headers: {
                productName: 'Nazwa produktu',
                componentName: 'Nazwa komponentu',
                amount: 'Nakład',
                processName: 'Nazwa procesu'
            }
        },
        jobParametersDialog: {
            title: 'Parametry zlecenia',
            qualityNotesButton: 'Uwagi jakościowe',
            fields: {
                jobName: 'Nazwa zlecenia',
                jobDescription: 'Uwagi do zlecenia'
            },
            headers: {
                name: 'Nazwa',
                productType: 'Rodzaj produktu',
                amount: 'Nakład',
                signalAmount: 'Sygnalne produktu',
                plannedSendDate: 'Data wysyłki',
                receiveFileDate: 'Data dostarczenia plików'
            },
            errors: {
                nameRequired: 'Proszę podać nazwę zlecenia.',
                nameTooLong: 'Nazwa nie może być dłuższa niż 80 znaków.',
                nameInvalidCharacters: 'Niedozwolone znaki – {chars}',
                duplicateProductName: 'Produkt o podanej nazwie już istnieje.',
                missingAmount: 'Proszę uzupełnić nakład.'
            }
        },
        jobNotesDialog: {
            title: 'Uwagi jakościowe',
            noData: 'Brak uwag jakościowych dla zlecenia',
            headers: {
                number: 'Numer',
                process: 'Proces',
                defect: 'Defekt',
                comment: 'Komentarz',
                reportedBy: 'Zgłaszający',
                createdAt: 'Data złożenia'
            }
        },
        productAmountDialog: {
            title: 'Edycja nakładu produktu',
            fields: {
                amount: 'Nakład:',
                extraAmount: 'Naddatek:'
            },
            errors: {
                required: 'Proszę podać nakład.',
                integer: 'Proszę podać liczbę naturalną.'
            }
        },
        productNameDialog: {
            title: 'Edycja nazwy produktu',
            fields: {
                name: 'Nazwa:'
            },
            errors: {
                required: 'Proszę podać nazwę produktu.',
                duplicate: 'Produkt o podanej nazwie już istnieje.'
            }
        },
        productSignalAmountDialog: {
            title: 'Edycja sygnalnych produktu',
            fields: {
                signalAmount: 'Sygnalne:'
            },
            errors: {
                required: 'Proszę podać sygnalne.',
                integer: 'Proszę podać liczbę naturalną.',
                minValue: 'Wartość nie może być ujemna.',
                notLessThanOriginal: 'Wartość nie może być mniejsza niż {value}.'
            }
        },
        orderProductAttachmentDialog: {
            title: 'Dodaj poprawione pliki produkcyjne',
            existingAttachmentAlert: 'Aby dodać nowy plik najpierw usuń istniejący z listy poniżej.',
            uploadRadioLabel: 'Wgraj plik do systemu',
            fileLabel: 'Plik produkcyjny',
            filePlaceholder: 'Wybierz plik',
            uploadButton: 'Wyślij',
            linkRadioLabel: 'Podaj link do pliku produkcyjnego',
            linkFieldLabel: 'Link do pliku',
            linkPlaceholder: 'Wklej link do plików',
            noData: 'Nie dodano pliku produkcyjnego.',
            headers: {
                fileName: 'Nazwa pliku'
            },
            errors: {
                maxSize: 'Przekroczono dopuszczalny rozmiar pliku: {size}MB.',
                invalidName: 'Nazwa pliku zawiera niedozwolone znaki - {chars}.',
                mustBePdf: 'Akceptowane są tylko pliki PDF.'
            }
        },
        impositionOrdinalNumbersDialog: {
            title: 'Edycja numeracji montaży',
            autoNumberButton: 'Autonumeracja',
            previousOrdinalNumber: 'Montaż',
            headers: {
                index: 'Lp.',
                previousOrdinalNumber: 'Montaż',
                ordinalNumber: 'Nowy nr montażu'
            },
            errors: {
                invalidOrdinalNumber: 'Numer montażu musi być unikalną liczbą całkowitą większą od zera.',
                duplicateOrdinalNumber: 'Numer montażu musi być unikalny.'
            }
        },
        manageComponentsDialog: {
            title: 'Edycja zbiorcza komponentów',
            headers: {
                productName: 'Nazwa produktu',
                foldingType: 'Rodzaj składania',
                component: 'Komponent',
                parts: 'Ilość użytków',
                amount: 'Nakład',
                imposition: 'Montaż'
            }
        },
        parallelComponentsDialog: {
            title: 'Edycja zbiorcza komponentów',
            headers: {
                productName: 'Nazwa produktu',
                foldingType: 'Rodzaj składania',
                component: 'Komponent',
                parts: 'Ilość użytków',
                nettoAmount: 'Nakład',
                process: 'Proces'
            }
        },
        impositionParametersDialog: {
            title: 'Parametry procesu',
            invalidDataTitle: 'Nieprawidłowe dane',
            componentFormatTooLarge: 'Format komponentu jest większy niż format arkusza',
            fields: {
                machine: 'Maszyna',
                paperType: 'Rodzaj papieru',
                paperName: 'Nazwa papieru',
                certificate: 'Certyfikat',
                sendPaperWaste: 'Wysyłka makulatury',
                paperCertificateName: 'Nazwa certyfikatu',
                rollWidth: 'Szerokość rolki',
                rollCutoff: 'Odcięcie rolki',
                formatA: 'Format A',
                formatB: 'Format B',
                impositionsAmount: 'Ilość montaży',
                service: 'Usługa',
                printMethod: 'Sposób druku',
                plateType: 'Rodzaj płyty',
                colorsA: 'Kolorystyka A',
                colorsB: 'Kolorystyka B',
                extraWasteAmount: 'Dodatkowe straty na zepsucie',
                sideA: 'Stron A',
                sideB: 'Stron B',
                sheetCountStep: 'Liczenie arkuszy co',
                colorTemplate: 'Wzór kolorystyczny',
                rubber: 'Guma',
                rubberNumber: 'Numer gumy',
                rubberFromImposition: 'Wybierz gumę z montażu',
                productsInSetAmount: 'Ilość produktów w komplecie',
                wasteAmount: 'Straty',
                wastePercent: 'Straty',
                description: 'Uwagi',
                componentFormatA: 'Format A',
                componentFormatB: 'Format B'
            },
            placeholders: {
                noPrint: 'bez zadruku',
                rubberNumberNoResults: 'Nie znaleziono'
            },
            hints: {
                allowedRange: 'Dopuszczalny zakres {range}',
                allowedRangeOr: 'Dopuszczalny zakres {range1} lub {range2}'
            },
            headers: {
                orderNumber: 'Nr zamówienia',
                productName: 'Nazwa produktu',
                foldingType: 'Rodzaj składania',
                component: 'Komponent',
                format: 'Format',
                parts: 'Użytki',
                nettoAmount: 'Nakład netto'
            },
            componentFormatDialog: {
                title: 'Edycja formatu komponentu'
            },
            colorSettings: {
                title: 'Ustawienia kolorystyki {side}',
                noColors: 'Nie dodano kolorów',
                headers: {
                    type: 'Typ',
                    color: 'Kolor',
                    coverage: 'Pokrycie (%)',
                    description: 'Opis'
                }
            },
            sections: {
                components: 'Komponenty'
            },
            errors: {
                invalidValue: 'Proszę podać prawidłową wartość',
                invalidWastePercent: 'Proszę podać prawidłową wartość z zakresu 0-25',
                invalidComponentFormat: 'Proszę podać prawidłowy format.',
                productsInSetAmount: 'Proszę podać liczbę całkowitą większą od 0.'
            }
        },
        taskParametersDialog: {
            title: 'Parametry procesu',
            fields: {
                machine: 'Maszyna',
                foldingType: 'Sposób falcowania',
                paperType: 'Rodzaj papieru',
                paperName: 'Nazwa papieru',
                paperFormatA: 'Format papieru A',
                paperFormatB: 'Format papieru B',
                stapleType: 'Rodzaj zszywki',
                glue: 'Klej',
                materials: 'Materiały',
                outputFormatA: 'Format A na wyjściu',
                outputFormatB: 'Format B na wyjściu',
                colorsA: 'Kolorystyka A',
                colorsB: 'Kolorystyka B',
                plateType: 'Rodzaj płyty',
                formatA: 'Format A',
                formatB: 'Format B',
                partsAfterCutting: 'Ilość użytków po krojeniu',
                dieCutter: 'Wykrojnik',
                dieCutterNumber: 'Numer wykrojnika',
                dieCutterPrice: 'Cena wykrojnika',
                transport: 'Transport',
                distance: 'Dystans',
                cost: 'Koszt',
                wasteAmount: 'Straty',
                wastePercent: 'Straty',
                description: 'Uwagi do procesu'
            },
            headers: {
                orderNumber: 'Nr zamówienia',
                productName: 'Nazwa produktu',
                foldingType: 'Rodzaj składania',
                component: 'Komponent',
                format: 'Format',
                parts: 'Użytki',
                nettoAmount: 'Nakład netto',
                componentName: 'Nazwa komponentu',
                outputFormatA: 'Format A wyjścia',
                outputFormatB: 'Format B wyjścia'
            },
            sections: {
                components: 'Komponenty'
            },
            actions: {
                addDieCutter: 'Dodaj wykrojnik',
                calculateCost: 'Oblicz koszt wysyłki',
                mountingPaper: 'Papier do montażu'
            },
            errors: {
                invalidValue: 'Proszę podać prawidłową wartość',
                invalidWastePercent: 'Proszę podać prawidłową wartość z zakresu 0-25'
            },
            materialsDialog: {
                title: 'Materiały',
                noData: 'Nie dodano materiałów',
                headers: {
                    name: 'Nazwa',
                    index: 'Indeks',
                    usedPercent: 'Zużycie (%)',
                    unit: 'Jednostka'
                }
            },
            sendingDialog: {
                title: 'Edycja rodzaju wysyłki',
                fields: {
                    transport: 'Transport',
                    distance: 'Dystans',
                    cost: 'Koszt'
                },
                actions: {
                    calculateCost: 'Oblicz koszt wysyłki'
                },
                errors: {
                    maxTwoDecimals: 'Maksymalnie 2 cyfry po przecinku'
                }
            },
            slicingFormatsDialog: {
                title: 'Formaty na wyjściu',
                fields: {
                    formatA: 'Format A',
                    formatB: 'Format B'
                },
                errors: {
                    minValue: 'Minimalna wartość {value}'
                }
            }
        },
        impositionPaperDialog: {
            title: 'Papier do montażu'
        },
        tooltips: {
            pendingMigration: 'Akcja będzie dostępna po migracji kolejnych etapów.'
        },
        notifications: {
            deleteProcessBlocked: 'Usunięcie procesu "{processName}" zostało zablokowane.',
            invalidJobConfiguration: 'Proszę poprawnie rozpisać zlecenie.',
            shippingOrdersViewNotMigrated: 'Widok zlecenia spedycyjnego nie jest jeszcze zmigrowany.',
            forwardedToTechnologist: 'Zlecenie przekazane do technologa.',
            closed: 'Zlecenie zostało zamknięte.',
            reopened: 'Zlecenie zostało otwarte.',
            cancelled: 'Zlecenie zostało anulowane.',
            materialsRequirementSent: 'Zapotrzebowanie zostało wysłane.',
            reprintCreated: 'Zlecenie dodruku zostało utworzone.'
        },
        errors: {
            loadFailed: 'Pobranie danych zlecenia nie powiodło się.'
        }
    },

    tooltips: {
        openDisabled: 'Otwórz'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń nie powiodło się.',
        fetchDetails: 'Pobranie danych zlecenia nie powiodło się.',
        fetchDetailsResources: 'Pobranie danych pomocniczych zlecenia nie powiodło się.',
        fetchJobNotes: 'Nie udało się pobrać danych o uwagach jakościowych.',
        fetchJobChangeHistory: 'Pobranie historii zmian dla zlecenia {id} nie powiodło się.',
        fetchJobImpositionStatuses: 'Pobranie statusów montaży dla zlecenia {id} nie powiodło się.',
        fetchJobPrintColours: 'Pobranie typów kolorów nie powiodło się.',
        fetchJobNumbers: 'Pobranie numerów zleceń nie powiodło się.',
        fetchOrderProduct: 'Pobranie produktu nie powiodło się.',
        fetchProcessesAvailableToAdd: 'Pobranie procesów nie powiodło się.',
        addTask: 'Dodanie procesu nie powiodło się.',
        saveImposition: 'Aktualizacja impozycji nie powiodła się.',
        saveTask: 'Aktualizacja procesu nie powiodła się.',
        deleteTask: 'Usunięcie procesu nie powiodło się.',
        copyTaskParameters: 'Kopiowanie parametrów procesu nie powiodło się.',
        fetchParallelComponents: 'Pobranie komponentów procesów równoległych nie powiodło się.',
        saveParallelComponents: 'Przypisanie komponentów do zadań nie powiodło się.',
        saveJob: 'Aktualizacja zlecenia nie powiodła się.',
        sendMaterialsRequirement: 'Wysłanie zapotrzebowania nie powiodło się.',
        updateOrderProduct: 'Aktualizacja produktu w zamówieniu nie powiodła się.',
        updateOrderProductComponent: 'Aktualizacja komponentu w zamówieniu nie powiodła się.',
        uploadOrderProductAttachment: 'Dodanie pliku produkcyjnego nie powiodło się.',
        deleteOrderProductAttachment: 'Usunięcie pliku produkcyjnego nie powiodło się.',
        reassignComponents: 'Edycja zbiorcza komponentów nie powiodła się.',
        reprintJob: 'Dodruk nie powiódł się.',
        printReports: 'Wygenerowanie raportu nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
